import * as types from './popupActionTypes.js';

export const setPopups = (popups) => ({ type: types.SET_POPUPS, popups: popups });
